import { render, staticRenderFns } from "./FarmLayout.vue?vue&type=template&id=4c4130cf&scoped=true&"
import script from "./FarmLayout.vue?vue&type=script&lang=js&"
export * from "./FarmLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4130cf",
  null
  
)

export default component.exports